<script lang="ts" setup>
import { Severity } from '@revolugo/common/types'
import Message from 'primevue/message'
import { computed } from 'vue'

import { RIcon } from '#atoms'
import { type RAlertProps, RAlertSeverity } from '#ds-types'

import preset from './RAlert.style.ts'

defineEmits<{
  close: [event: Event]
}>()

const props = defineProps<RAlertProps>()

const setColor = computed(() => {
  switch (props.severity) {
    case RAlertSeverity.Success:
      return 'green-600'
    case RAlertSeverity.Error:
      return 'red-600'
    case RAlertSeverity.Warn:
      return 'orange-600'
    case RAlertSeverity.Info:
      return 'blue-600'
    case RAlertSeverity.Contrast:
    case RAlertSeverity.Secondary:
    case Severity.Contrast:
    case Severity.Danger:
    case Severity.Help:
    case Severity.Info:
    case Severity.Primary:
    case Severity.Secondary:
    case Severity.Success:
    case Severity.Warn:
    case undefined:
    default:
      return 'surface-600'
  }
})
</script>

<template>
  <Message
    v-bind="$props"
    :pt="preset"
    :severity="severity ? severity : ''"
    data-testid="r-alert"
    @close="$emit('close', $event)"
  >
    <template
      #icon
      v-if="icon"
    >
      <p class="flex items-center w-5 h-5">
        <RIcon
          :icon="icon"
          :color="setColor"
          size="medium"
          data-testid="r-alert-icon"
        />
      </p>
    </template>
    <slot>
      <span
        data-testid="r-alert-message"
        class="text-neutral-950"
        >{{ message }}</span
      >
    </slot>
  </Message>
</template>
